const emoji: string[] = ['😎', '🤑', '🤩', '😜', '😃', '😁', '😂'];
export default emoji;